import React from "react";
import { Card, Typography, Table, Tooltip } from "antd";

const { Text } = Typography;
function AdqCard(props) {
    //try to achive using props method once approche finalized,romve this code and add common method
    for(var i=0; i<props.columns.length; i++){
      if(props.columns[i].dataIndex === "attributeName"){
        let gruid = props.columns.findIndex(x => x.title === 'Group Name')
            if (gruid !== -1) {
              props.columns.splice(gruid, 1);
            }
            props.cardData.children=[];
      }
      
    }
  return (
    <div className="mt-1">
      {props.columns && props.cardData ? (
        <Card title={JSON.stringify(props.cardData.action)}>
          {props.columns.map((column) => {
            if(column.title !== "Select"){
              return (
                <p className="listViewSection">
                  <span strong className="grid" style={{ fontWeight: "600" }}>
                    {column.title}
                  </span>
                  
                  <Tooltip  
                  title= { props.cardData[column.dataIndex] } 
                  >
                    { 
                    //  // added for Roles ScreenName ...
                    <div className="d-none">
                      {
                      props.cardData[column.dataIndex] && props.cardData[column.dataIndex].length > 40 ? 
                       props.cardData[column.dataIndex]  =  props.cardData[column.dataIndex].substring(0,40) 
                       : props.cardData[column.dataIndex]}

                    </div>
                    }
                    <div 
                      className={ column.title !== 'Action' ? "tableToColumn" : "tableToColumn " } >
                      {/*  use if multi actions are showing "tableToColumn actBTN" */}
                        <Table
                          columns={[column]}
                          dataSource={[props.cardData]}
                          pagination={false}
                          defaultExpandAllRows
                        />
                      </div>
                  </Tooltip>
                </p>
              )
            }
          }
          )}
        </Card>
      ) : (
        ""
      )}
    </div>
  );
}
export default AdqCard;
